import React from 'react';
import { MatchColumnSelect } from '../../../components/Selects/MatchColumnSelect';
import { getFieldSort, getFieldOptions } from '../utils/getFieldConfiguration';
import { useRsi } from '../../../hooks/useRsi';
import { Box, Typography } from '@beeline.com/bp-design-system';
import { MatchedOptions, MatchedSelectColumn, MatchedSelectOptionsColumn } from '../types';

interface Props<T> {
  option: MatchedOptions<T> | Partial<MatchedOptions<T>>;
  column: MatchedSelectColumn<T> | MatchedSelectOptionsColumn<T>;
  onSubChange: (val: T, index: number, option: string) => void;
}

export const SubMatchingSelect = <T extends string>({ option, column, onSubChange }: Props<T>) => {
  const { translations, fields } = useRsi<T>();
  const sort = getFieldSort(fields, column.value);
  const options = getFieldOptions(fields, column.value);
  const value = options.find((opt) => opt.value === option.value);

  return (
    <Box my="8px">
      <Typography>{option.entry}</Typography>
      <MatchColumnSelect
        value={value}
        placeholder={translations.matchColumnsStep.subSelectPlaceholder}
        onChange={(value) => onSubChange(value?.value as T, column.index, option.entry!)}
        options={options}
        name={option.entry}
        sort={sort}
      />
    </Box>
  );
};
